import { CommonComponentContext } from "../common/utils/CommonComponentContext";
import { useClientConfigImpl } from "../reducers/clientConfigSlice";
import useAppState from "../common/hooks/appStateHook";
import { useMemo } from "react";
import { useGlossaryImpl } from "../reducers/glossarySlice";
import { upsertSetting, useSetting, useSettingsLoading } from "../reducers/settingSlice";

export const CommonComponentContextProvider = ({ children }) => {
    const { token } = useAppState();
    const clientConfig = useClientConfigImpl(token);
    const glossary = useGlossaryImpl();
    
    const configStatuses = t => [
        { label: t('notStarted'), value: undefined, color: '#e98989' },
        { label: t('inProgress'), value: 'inProgress', color: '#FFB74D' },
        { label: t('awaitingSignoff'), value: 'awaitingSignoff', color: '#fff176' },
        { label: t('complete'), value: 'complete', color: '#81c784' },
        { label: t('notApplicable'), value: 'na', color: '#adadad' }
    ];

    const value = useMemo(() => ({ clientConfig, glossary, upsertSetting, useSetting, useSettingsLoading, configStatuses }), [clientConfig, glossary]);
    
    return <CommonComponentContext.Provider value={value}>
        {children}
    </CommonComponentContext.Provider>
}